//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SectionBannerOnMap",
  components: {
    Button: () => import("@/components/common/Button"),
    Section: () => import("@/components/common/Section")
  },
  props: {
    entity: {
      type: String,
      default: () => null
    },
    id: {
      type: Number,
      default: () => null
    },
    // eslint-disable-next-line vue/prop-name-casing
    city_id: {
      type: Number,
      default: () => null
    }
  },
  computed: {
    link () {
      if (this.id) {
        return `?entity=${this.entity}&id=${this.id}`
      } else if (!this.id && this.entity) {
        return `?entity=${this.entity}`
      } else if (this.city_id) {
        return `?city_id=${this.city_id}&entity=places`
      } else {
        return ''
      }
    }
  }
}
